import { Component, Input, Output, EventEmitter } from '@angular/core';
var AmdOverlayComponent = /** @class */ (function () {
    function AmdOverlayComponent() {
        this.isActive = false;
        this.isFixed = false;
        this.onOverlayClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AmdOverlayComponent.prototype.onClick = function () {
        this.onOverlayClicked.emit();
    };
    AmdOverlayComponent.decorators = [
        { type: Component, args: [{
                    selector: 'amd-overlay',
                    template: "<div class=\"amd-overlay\" [class.amd-overlay--fixed]=\"isFixed\" (click)=\"onClick()\" [class.amd-overlay--visible]=\"isActive\"> </div>"
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdOverlayComponent.ctorParameters = function () { return []; };
    AmdOverlayComponent.propDecorators = {
        'isActive': [{ type: Input },],
        'isFixed': [{ type: Input },],
        'onOverlayClicked': [{ type: Output },],
    };
    return AmdOverlayComponent;
}());
export { AmdOverlayComponent };
function AmdOverlayComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdOverlayComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdOverlayComponent.ctorParameters;
    /** @type {?} */
    AmdOverlayComponent.propDecorators;
    /** @type {?} */
    AmdOverlayComponent.prototype.isActive;
    /** @type {?} */
    AmdOverlayComponent.prototype.isFixed;
    /** @type {?} */
    AmdOverlayComponent.prototype.onOverlayClicked;
}
//# sourceMappingURL=overlay.component.js.map
//# sourceMappingURL=overlay.component.js.map
